import { render } from "./suppliersMenu.vue?vue&type=template&id=6f721097"
import script from "./suppliersMenu.vue?vue&type=script&lang=js"
export * from "./suppliersMenu.vue?vue&type=script&lang=js"

import "./suppliersMenu.vue?vue&type=style&index=0&id=6f721097&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__